import { useState } from "react";
import "./header.css";
import { Container } from "../Container/container";
import { Sign } from "../SignUpModal/signUpModal";
import { ProfileModal } from "../ProfileModal/profileModal";

import logo from "../../images/logo.png";
import userheader from "../../images/userheader.png";

export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const handleSignIn = () => {
    setIsLoggedIn(true);
    setIsModalOpen(false);
  };

  const handleSignOut = () => {
    setIsLoggedIn(false);
  };



  return (
    <header className="header">
      <Container>
        <div className="header__div">
          <img className="header__logo" src={logo} alt="Logo" />
          <ul className="header__ul">
            <li><a href="#news" className="header__item">News</a></li>
            <li><a href="#contacts" className="header__item">Contacts</a></li>
            <li><a href="#menu" className="header__item">Menu</a></li>
          </ul>

          {isLoggedIn ? (
            <button className="header__button" onClick={handleSignOut}>Sign Out</button>
          ) : (
            <button className="header__button" onClick={() => setIsModalOpen(true)}>Sign Up</button>
          )}

          <button
            className="header__user-button"
            onClick={() => setIsProfileOpen(true)}
          >
            <img className="header__user" src={userheader} alt="User" />
          </button>

          <div className="header__mobile">
            <img className="header__logo2" src={logo} alt="" />
            <button
              className="header__button2"
              onClick={() => setIsOpen(!isOpen)}
            >
              Menu
            </button>
          </div>

          {isOpen && (
            <div className="header__burger">
              <ul className="header__ul2">
                <li><a href="#news" className="header__item">News</a></li>
                <li><a href="#contacts" className="header__item">Contacts</a></li>
                <li><a href="#menu" className="header__item">Menu</a></li>
              </ul>
              <div className="header__part">
                <button
                  className="header__user-button"
                  onClick={() => setIsProfileOpen(true)}
                >
                  <img className="header__user" src={userheader} alt="User" />
                </button>
                {isLoggedIn ? (
                  <button className="header__button" onClick={handleSignOut}>Sign Out</button>
                ) : (
                  <button className="header__button" onClick={() => setIsModalOpen(true)}>Sign Up</button>
                )}
              </div>
            </div>
          )}
        </div>

        {isModalOpen && (
          <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
            <div onClick={(e) => e.stopPropagation()}>
              <Sign onSignUp={handleSignIn} />
            </div>
          </div>
        )}

        {isProfileOpen && (
          <ProfileModal
            user={{ username: "User", email: "user@mail.com", password: "123456" }}
            onClose={() => setIsProfileOpen(false)}
          />
        )}
      </Container>
    </header>
  );
};